function getVersionFromDocument(doc: Document): string | null {
  return (
    doc.querySelector<HTMLMetaElement>('meta[name="build-version"]')?.getAttribute('content') ??
    null
  )
}

export function parseBuildVersion(html: string): string | null {
  return getVersionFromDocument(new DOMParser().parseFromString(html, 'text/html'))
}

export function getCurrentBuildVersion(): string | null {
  return getVersionFromDocument(document)
}

export function createThrottledExceptionLogger(throttleMs = 5 * 60 * 1000) {
  let lastLoggedAt = 0
  return (error: unknown) => {
    const now = Date.now()
    if (now - lastLoggedAt > throttleMs) {
      lastLoggedAt = now
      ;(window as any).appInsights?.trackException({ exception: error as Error })
    }
  }
}
